module.exports = __webpack_public_path__ + "img/symbol_0.b48bef30.png";